import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'react-use';

import OnboardingTutorial from '@pkg/components/OnboardingTutorial/OnboardingTutorial';
import { useAppDispatch } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import { detailViewActions } from '@app/store/slices';

import { ONBOARDING_ACTIVITY_CLASS, ONBOARDING_NDV_OWNER_CLASS } from '../styles';

const NDV_ONBOARDING_STORE_KEY = 'ndv-onboarding';

type OnboardSteps = 'activity' | 'ownerModule';

export const NFTDetailViewOnboarding = () => {
    const { t: translate } = useTranslation('onboarding');
    const dispatch = useAppDispatch();
    const { tablet } = useMediaQuery();

    const [isNDVOnboardingShown, setIsNDVOnboardingShown] = useLocalStorage(NDV_ONBOARDING_STORE_KEY);
    const [onboardStep, setOnboardStep] = useState<OnboardSteps>('activity');

    const [showNDVOnboarding, setShowNDVOnboarding] = useState(false);

    const onCloseNDVOnboarding = () => {
        setIsNDVOnboardingShown(true);
        setShowNDVOnboarding(false);
    };

    const onNDVSwitchDOMElement = () => {
        if (onboardStep == 'ownerModule') return onCloseNDVOnboarding();
        const ownerModule = document.querySelector(`.${ONBOARDING_NDV_OWNER_CLASS}`);
        if (ownerModule) {
            ownerModule.scrollIntoView({ block: 'center', behavior: 'smooth' });
            setOnboardStep('ownerModule');
        } else {
            onCloseNDVOnboarding();
        }
    };

    useEffect(() => {
        if (isNDVOnboardingShown) return;
        if (tablet) {
            const handler = () => {
                dispatch(detailViewActions.setShowActivitySidebar(true));
                setShowNDVOnboarding(true);
            };

            const timeout = setTimeout(handler, 2000);
            return () => clearTimeout(timeout);
        }
    }, [dispatch, isNDVOnboardingShown, tablet]);

    const highlightElement = onboardStep === 'activity' ? ONBOARDING_ACTIVITY_CLASS : ONBOARDING_NDV_OWNER_CLASS;

    if (tablet && showNDVOnboarding)
        return (
            <OnboardingTutorial
                useLockScroll={false}
                highlightElement={highlightElement}
                onClose={onCloseNDVOnboarding}
                onSlideChange={onNDVSwitchDOMElement}
                size="medium"
                slides={[
                    {
                        title: translate('activity-panel__slide1__title'),
                        content: translate('activity-panel__slide1__content'),
                        button: translate('activity-panel__slide1__button'),
                        imageURL: '/assets/img/onboarding/activity-panel.webp',
                    },
                    {
                        title: translate('activity-panel__slide2__title'),
                        content: translate('activity-panel__slide2__content'),
                        button: translate('activity-panel__slide2__button'),
                        imageURL: '/assets/img/onboarding/owner-panel.png',
                    },
                ]}
            />
        );

    return null;
};
